import axios from "axios";

const providerManagerEntitiesUrl = "/api/v1/provider_manager_entities";

const providerManagerEntitiesApi = {
  fetch: () => axios.get(providerManagerEntitiesUrl),
  show: id => axios.get(`${providerManagerEntitiesUrl}/${id}`),
  create: payload =>
    axios.post(providerManagerEntitiesUrl, {
      provider_manager_entity: payload,
    }),
  update: (id, payload) =>
    axios.put(`${providerManagerEntitiesUrl}/${id}`, {
      provider_manager_entity: payload,
    }),
  fetchTemplate: id =>
    axios.get(`${providerManagerEntitiesUrl}/${id}/fetch_template`),
  fetchTemplatelessEntities: () =>
    axios.get(`${providerManagerEntitiesUrl}/fetch_templateless_entities`),
};

export default providerManagerEntitiesApi;
